import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface Props {
  requiredPlan: string;
  currentPlan: string;
  licenseHref: string;
  onClose: () => void;
}

export function UpsellInterstitial({ requiredPlan, currentPlan, licenseHref, onClose }: Props) {
  const { t } = useTranslation();
  return (
    <AlertDialog open onOpenChange={(open) => { if (!open) onClose(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("upsell.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("upsell.description", { required: requiredPlan, current: currentPlan })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t("upsell.close")}
          </Button>
          <Button asChild>
            <Link to={licenseHref}>{t("upsell.cta")}</Link>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
